import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiManagerService {
  private state: SERVER_TYPE = SERVER_TYPE.production;

  constructor() { }

  getApi(): string{
    switch(this.state){
      case 0: return environment.localhostTestApi;
      case 1: return environment.spooortsApi;
      default: return environment.spooortsApi;
    }
  }

  getOriginalApi(){
    return environment.spooortsApi
  }

  getLocalHost(){
    return environment.localhostTestApi;
  }
}

export enum SERVER_TYPE{
  localhost,
  production
}
